module.exports = __webpack_public_path__ + "static/media/twitch.baefdb2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/twitch.svg
// module id = 208
// module chunks = 0